import React from 'react';
interface Fact {
  label: string;
  value: string;
  detail?: string;
}
export function NairobiAtGlance() {
  const facts: Fact[] = [{
    label: 'Population',
    value: '4.8 Million',
    detail: "Kenya's largest city"
  }, {
    label: 'Elevation',
    value: '1,795 meters',
    detail: '5,889 feet above sea level'
  }, {
    label: 'Coordinates',
    value: '1.2921° S',
    detail: '36.8219° E'
  }, {
    label: 'Airport',
    value: 'JKIA (NBO)',
    detail: '15km from city center'
  }, {
    label: 'Currency',
    value: 'Kenyan Shilling',
    detail: 'KES (1 USD ≈ 150 KES)'
  }, {
    label: 'Time Zone',
    value: 'EAT (UTC+3)',
    detail: 'No daylight saving'
  }, {
    label: 'Calling Code',
    value: '+254',
    detail: 'International dialing'
  }, {
    label: 'Electricity',
    value: '240V, 50Hz',
    detail: 'UK-style 3-pin plugs'
  }];
  const languages = [{
    name: 'English',
    status: 'Official'
  }, {
    name: 'Swahili',
    status: 'Official'
  }, {
    name: 'Sheng',
    status: 'Street slang'
  }];
  const quickTips = ["Matatus or Nganya are local minibuses - affordable, exciting, exhilarating. A must-have experience if you're ever in Nairobi", 'Uber, Bolt, and Little Cab widely available and safe', 'Bargaining expected at markets', 'Tap water safe to drink', 'Traffic heavy 7-9 AM and 5-7 PM', 'Tipping 10% customary at restaurants'];
  return <div className="bg-white border border-gray-200" data-id="element-89">
      {/* Facts Grid */}
      <div className="p-10" data-id="element-90">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12" data-id="element-91">
          {facts.map((fact, index) => <div key={index} className="text-center" data-id="element-92">
              <p className="text-xs text-gray-500 mb-2 uppercase tracking-widest font-light" data-id="element-93">
                {fact.label}
              </p>
              <p className="text-2xl font-light text-gray-900 mb-1" data-id="element-94">
                {fact.value}
              </p>
              {fact.detail && <p className="text-xs text-gray-600 font-light" data-id="element-95">
                  {fact.detail}
                </p>}
            </div>)}
        </div>

        {/* Languages */}
        <div className="mb-12 pb-12 border-b border-gray-200" data-id="element-96">
          <h4 className="text-xs font-light text-gray-500 mb-6 uppercase tracking-widest text-center" data-id="element-97">
            Languages Spoken
          </h4>
          <div className="flex flex-wrap gap-4 justify-center" data-id="element-98">
            {languages.map((lang, index) => <div key={index} className="px-6 py-3 border border-gray-900 text-gray-900" data-id="element-99">
                <span className="font-light text-sm" data-id="element-100">{lang.name}</span>
                <span className="text-xs text-gray-500 ml-2 font-light" data-id="element-101">
                  ({lang.status})
                </span>
              </div>)}
          </div>
        </div>

        {/* Quick Tips */}
        <div data-id="element-102">
          <h4 className="text-xs font-light text-gray-500 mb-6 uppercase tracking-widest text-center" data-id="element-103">
            Essential Tips
          </h4>
          <div className="space-y-4" data-id="element-104">
            {quickTips.map((tip, index) => <div key={index} className="flex items-start gap-4 p-5 bg-gray-50 border border-gray-100" data-id="element-105">
                <div className="w-1 h-1 bg-amber-500 rounded-full mt-2 flex-shrink-0" data-id="element-106" />
                <p className="text-sm text-gray-700 font-light leading-relaxed" data-id="element-107">
                  {tip}
                </p>
              </div>)}
          </div>
        </div>
      </div>

      {/* Footer Stats */}
      <div className="p-10 bg-gray-50 border-t border-gray-200" data-id="element-108">
        <div className="grid grid-cols-3 gap-8 text-center" data-id="element-109">
          <div data-id="element-110">
            <p className="text-4xl font-light text-gray-900 mb-2" data-id="element-111">696 km²</p>
            <p className="text-xs text-gray-600 uppercase tracking-widest font-light" data-id="element-112">
              Total Area
            </p>
          </div>
          <div data-id="element-113">
            <p className="text-4xl font-light text-gray-900 mb-2" data-id="element-114">1899</p>
            <p className="text-xs text-gray-600 uppercase tracking-widest font-light" data-id="element-115">
              Founded
            </p>
          </div>
          <div data-id="element-116">
            <p className="text-4xl font-light text-gray-900 mb-2" data-id="element-117">47</p>
            <p className="text-xs text-gray-600 uppercase tracking-widest font-light" data-id="element-118">
              Counties in Kenya
            </p>
          </div>
        </div>
      </div>
    </div>;
}